<template>
    <div class="userSteps_header border-bottom d-flex align-items-center align-items-center justify-content-between">
        <a v-if="current_route != 'Get_OTP' && current_route !='Image' && current_route != 'personal_details'"
            :href="(store.user.access_token) ? `${static_vars.domainURL}dashboard` : `${static_vars.domainURL}`"
            class="lightTheme logo d-block"><img src="/assets/images/logo.svg" :alt="$t('view_header.text5')"
                :title="$t('view_header.text5')" /></a>
        <a v-else class="lightTheme logo d-block"><img src="/assets/images/logo.svg" :alt="$t('view_header.text5')"
                :title="$t('view_header.text5')" /></a>
        <a v-if="current_route != 'Get_OTP' && current_route !='Image' && current_route != 'personal_details'"
            :href="(store.user.access_token) ? `${static_vars.domainURL}dashboard` : `${static_vars.domainURL}`"
            class="darkTheme logo d-none"><img src="/assets/images/whiteLogo.svg" :alt="$t('view_header.text5')"
                :title="$t('view_header.text5')" /></a>
        <a v-else class="darkTheme logo d-none"><img src="/assets/images/whiteLogo.svg" :alt="$t('view_header.text5')"
                :title="$t('view_header.text5')" /></a>
        <div class="rightBTN d-flex align-items-center">
            <div class="d-flex align-items-center justify-content-end position-relative">
                <a href="javascript:void(0)" class="d-none d-lg-flex align-items-center me-md-4 me-2 medium linkBtn"
                    @click.prevent="openMenu = !openMenu">
                    <!--img :src="`${static_vars.imagePath}/assets/images/mobileApp.svg`" alt="Icon" title="ZuluTrade App Download" class="mobileAppIcon me-md-2" /--><span
                        class="masked"></span>{{ $t('view_header.text1') }}</a>
                <div class="maxAuto dropdown-menu userLogged p-3 dropdown-menu-end text-center"
                    :class="openMenu ? 'show' : ''">
                    <p class="mb-0">{{ $t('view_header.text2') }}</p>
                    <ul class="mb-0 d-flex align-items-center">
                        <img width="140" height="140" class="mx-auto cardborder" :src="`${static_vars.imagePath}/assets/images/zuluScan.png`" :alt="$t('view_header.text6')" :title="$t('view_header.text6')">
                    </ul>
                    <ul class="mb-0 d-flex align-items-center">
                        <li>
                            <a href="https://apps.apple.com/gr/app/zulutrade/id336913058" target="_blank"
                                class="fadebg appStore text-white medium f-14 me-2">
                                <img src="/assets/images/iosIcon.png" :alt="$t('view_header.text7')"
                                    :title="$t('view_header.text7')">
                                <span>{{ $t('view_header.text3') }}</span>
                            </a>
                        </li>
                        <li>
                            <a href="https://play.google.com/store/apps/details?id=zulu.trade.app" target="_blank"
                                class="fadebg appStore text-white medium f-14">
                                <img src="/assets/images/androidIcon.png" :alt="$t('view_header.text8')"
                                    :title="$t('view_header.text8')">
                                <span>{{ $t('view_header.text4') }}</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
                <a id="theme-toggle" class="d-flex" :title="$t('view_header.text9')"
                    :class="[{ 'light': currentTheme == 'light' }, { 'dark': currentTheme == 'dark' }]" href="javascript:void(0)"
                    @click="changeTheme()">
                    <vue-feather class="me-1" size="20" type="moon" v-if="currentTheme == 'light'"></vue-feather>
                    <vue-feather class="me-1" size="20" type="sun" v-if="currentTheme == 'dark'"></vue-feather>
                </a>
                <!-- <a href="javascript:void(0)" class="medium linkBtn me-md-5 me-2"> English</a> -->
                <!-- <a href="javascript:void(0)" class="medium linkBtn" @click="logout()" v-if="store.user.access_token"> Logout</a> -->
                <a title="Logout" href="javascript:void(0)" class="dark ms-3 logout d-flex" @click="logout()"
                    v-if="store.user.access_token || localToken !== null"> <vue-feather size="20"
                        type="power"></vue-feather> </a>
            </div>
        </div>
</template>

<script>
import { useMainStore } from "@/store";
export default {
    setup() {
        const store = useMainStore();
        return { store };
    },
    data() {
        return {
            openMenu: false,
            currentTheme: '',
            current_route: this.$route.name,
            localToken:localStorage.getItem('zulutoken')
        }
    },
    methods: {
        changeTheme() {
            if (this.currentTheme == 'light') {
                this.currentTheme = 'dark'
            } else {
                this.currentTheme = 'light'
            }
        },
        logout() {
            this.store.logout()
        },
    },
    mounted() {
        if (localStorage.getItem('theme') === null) {
            localStorage.setItem('theme', 'light');
        }
        var toggle = document.getElementById("theme-toggle");
        var storedTheme = localStorage.getItem('theme') || (window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light");
        if (storedTheme) {
            document.documentElement.setAttribute('data-theme', storedTheme)
        }
        if (toggle) {
            toggle.onclick = function () {
                var currentTheme = document.documentElement.getAttribute("data-theme");
                var targetTheme = "light";
                if (currentTheme === "light") {
                    targetTheme = "dark";
                }
                document.documentElement.setAttribute('data-theme', targetTheme)
                localStorage.setItem('theme', targetTheme);
            };
        }
        this.currentTheme = localStorage.getItem('theme')
    },

}
</script>